// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1_wxQ","container":"styles_container__3keoc","title":"styles_title__2Xkp_","wrapper":"styles_wrapper__tfWHm","answer":"styles_answer__3fElj"};